export { default } from '@telexpress_auth/vue-batchtag-management';
